import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService, AuthType } from '../services/authentication.service';
import { catchError, map, tap, timeout } from 'rxjs/operators';
import { filter, Observable, of, switchMap, take } from 'rxjs';
import { DEFAULT_OAUTH_CONFIG_ID, STAFF_OAUTH_CONFIG_ID } from '../services/app-config.service';
import { OidcSecurityService } from "angular-auth-oidc-client";

@Injectable({
  providedIn: 'root',
})
export class AuthInitGuard implements CanActivate {
  constructor(
    private authService: AuthenticationService,
    private oidcSecurityService: OidcSecurityService,
    private router: Router
  ) {}

  // canActivate(): Observable<boolean> {
  //   // If staff is authenticated do not init the default auth
  //   return this.oidcSecurityService.checkAuth(undefined, STAFF_OAUTH_CONFIG_ID).pipe(
  //     take(1),
  //     tap(({ isAuthenticated }) => {
  //       if (!isAuthenticated) {
  //         this.authService.init(AuthType.Default);
  //       } else {
  //         console.debug('[AuthInitGuard] Staff already authenticated, skipping default init');
  //       }
  //     }),
  //     map(() => true)
  //   );
  // }

  // canActivate(): Observable<boolean> {
  //   return this.oidcSecurityService.checkAuth(undefined, STAFF_OAUTH_CONFIG_ID).pipe(
  //     take(1),
  //     switchMap(({ isAuthenticated }) => {
  //       if (isAuthenticated) {
  //         console.debug('[AuthInitGuard] Staff already authenticated, skipping default init');
  //         return of(true);
  //       }
  //
  //       // Trigger init for default auth and wait for authenticated$ to emit true
  //       this.authService.init(AuthType.Default);
  //
  //       // Wait until authenticated$ changes to true
  //       return this.authService.authenticated$.pipe(
  //         filter((authenticated) => authenticated === true),
  //         take(1),
  //         map(() => true),
  //         // timeout safety - if it takes too long, allow to proceed
  //         timeout(10000),
  //         catchError(() => of(true))
  //       );
  //     })
  //   );
  // }
  canActivate(): Observable<boolean> {
    const routerUrl = this.router.url || '';
    const hasCodeOrState = window.location.search.includes('code=') || window.location.search.includes('state=');

    // 1) Jeśli callback na /staff-login -> sprawdzaj staff config
    if (hasCodeOrState && routerUrl.startsWith('/staff-login')) {
      console.log('[AuthInitGuard] Callback detected on /staff-login, checking staff config');
      return this.oidcSecurityService.checkAuth(window.location.href, STAFF_OAUTH_CONFIG_ID).pipe(
        take(1),
        map(() => true),
        catchError(() => of(true))
      );
    }

    // 2) Jeśli callback na / (default) -> sprawdzaj default config
    if (hasCodeOrState && routerUrl.startsWith('/')) {
      console.log('[AuthInitGuard] Callback detected on /, checking default config');
      return this.oidcSecurityService.checkAuth(window.location.href, DEFAULT_OAUTH_CONFIG_ID).pipe(
        take(1),
        map(() => true),
        catchError(() => of(true))
      );
    }

    // 3) Normalny przypadek: jeśli staff jest zalogowany -> nie inicjuj default
    return this.oidcSecurityService.checkAuth(undefined, STAFF_OAUTH_CONFIG_ID).pipe(
      take(1),
      switchMap(({ isAuthenticated }) => {
        if (isAuthenticated) {
          console.debug('[AuthInitGuard] Staff already authenticated, skipping default init');
          return of(true);
        }

        console.log('[AuthInitGuard] Staff not authenticated!!!!!!!!!!!!!');
        // return of(false);

        // Brak staff sesji -> uruchom default init
        this.authService.init(AuthType.Default);

        // Nie blokuj zbyt długo na guardzie
        return this.authService.authenticated$.pipe(
          take(1),
          map(() => true),
          timeout(10000),
          catchError(() => of(true))
        );
      })
    );
  }
}
